import { Text } from '../../primitives';
import { styled } from '../../theme';

export const Wrapper = styled(Text).attrs((props) => ({
	...props,
	style: 'bold',
	size: 'xs',
	element: 'span',
}))`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: ${({ theme }) => `${theme.space.xs}px ${theme.space.sm}px`};
	border-radius: ${({ theme }) => theme.space.lg}px;
	background: ${({ theme }) => theme.color.green.base};
	color: ${({ theme }) => theme.color.white.base};
	letter-spacing: 0.08em;
	text-transform: uppercase;
`;
